"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _logger = require("@insided/shared/services/logger");

var _axios = _interopRequireDefault(require("axios"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var SearchSmartSummary = /*#__PURE__*/(0, _createClass2.default)(function SearchSmartSummary() {
  var _this = this;

  (0, _classCallCheck2.default)(this, SearchSmartSummary);
  (0, _defineProperty2.default)(this, "cancelToken", void 0);
  (0, _defineProperty2.default)(this, "applicationId", null);
  (0, _defineProperty2.default)(this, "apiKey", null);
  (0, _defineProperty2.default)(this, "firstAutomaticSummaryPerformed", false);
  (0, _defineProperty2.default)(this, "lastSearchData", null);
  (0, _defineProperty2.default)(this, "getSmartSummary", /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(payload, isUnifiedIndex) {
      var _this$cancelToken;

      var result, _result;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              (_this$cancelToken = _this.cancelToken) === null || _this$cancelToken === void 0 ? void 0 : _this$cancelToken.cancel();

              if (!(!_this.applicationId || !_this.apiKey)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", null);

            case 3:
              _this.cancelToken = _axios.default.CancelToken.source();
              result = null;
              _context.prev = 5;
              _context.next = 8;
              return _axios.default.post(isUnifiedIndex ? '/search/searchSummaryV2' : '/search/searchSummary', _objectSpread({
                applicationId: _this.applicationId,
                apiKey: _this.apiKey
              }, payload), {
                cancelToken: _this.cancelToken.token
              });

            case 8:
              result = _context.sent;
              return _context.abrupt("return", (_result = result) === null || _result === void 0 ? void 0 : _result.data);

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](5);

              _logger.logger.error(_context.t0, {
                component: 'SearchSmartSummaryService',
                action: 'getSmartSummary'
              });

              return _context.abrupt("return", null);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 12]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
});
var searchSmartSummaryService = new SearchSmartSummary();
var _default = searchSmartSummaryService;
exports.default = _default;